export default __webpack_public_path__ + "static/tabs-content-dont-c185f3aeb2d553762c8bdcff3ade8ff956d055197079a0b1f0bffef55e8aa461.png";